<div class="title-section">{{ title }}</div>

<div class="swiper-slider">
  <div
    [ngClass]="[
      'arrow-slider',
      'previous-arrow',
      title,
      swiperRef?.swiper.isBeginning ? 'swiper-button-disabled' : '',
    ]"
    *ngIf="platformType === PlatformEnum.desktop"
    (click)="swiperRef?.swiper.slidePrev()"
  >
    <ion-icon
      slot="icon-only"
      name="arrow-back-circle-outline"
      data-cy="swiper-back-icon"
    >
    </ion-icon>
  </div>
  <swiper-container
    #swiperRef
    slides-per-view="auto"
    navigation-prev-el=".previous-arrow {{ title }}"
    navigation-next-el=".next-arrow {{ title }}"
    observer="true"
    observe-parents="true"
    resize-observer="true"
  >
    <swiper-slide
      *ngFor="let product of products; trackBy: trackByIndex; let index = index"
      [ngClass]="platformType === PlatformEnum.desktop ? 'desktop' : 'touch'"
    >
      <app-product-detail-card
        observeIntersection
        [productDetails]="product"
        [navigationDisabled]="false"
        [carouselPosition]="index + 1"
        [linkSource]="linkSource"
        [merchFeature]="merchFeature"
        [addMethod]="addMethod"
        [isGuestUser]="isGuestUser"
        [threshold]="0.75"
        (quantityUpdateEmitter)="onQuantityUpdate($event, index, product)"
        (intersectionChange)="onIntersectionChange(index, $event)"
        (impression)="onProductImpression(product?.recToken)"
        (clickEventEmitter)="onProductClick(product?.recToken)"
        [variant]="product?.variant"
      >
      </app-product-detail-card>
    </swiper-slide>
  </swiper-container>
  <div
    [ngClass]="[
      'arrow-slider',
      'next-arrow',
      title,
      swiperRef?.swiper.isEnd ? 'swiper-button-disabled' : '',
    ]"
    *ngIf="platformType === PlatformEnum.desktop"
    (click)="swiperRef?.swiper.slideNext()"
  >
    <ion-icon
      slot="icon-only"
      name="arrow-forward-circle-outline"
      data-cy="forward-swiper-icon"
    ></ion-icon>
  </div>
</div>
